
<!-- Copyright (c) Konnecta Systems. All rights reserved. -->
<!-- Licensed under the Custom License. See LICENSE file in the project root for full license information. -->
<!-- This was autogenerated by zAppDev. -->
<router-outlet></router-outlet>
<p-confirmDialog [style]="{'min-width': '30vw'}" [styleClass]="options?.className"></p-confirmDialog>
<p-confirmPopup key="confirmPopUp" ></p-confirmPopup>